import instance from "@/services/api";

export const ncaAutosignAPI = {
  /**
   * Получить список накладных для автоподписания
   */
  async getPendingInvoices() {
    return await instance()
      .get("/provider_request/nca_autosign/pending/")
      .then((res) => res?.data);
  },

  /**
   * Запустить автоподписание накладных
   * @param {number} provider_nca_key_store_id - ID ключа для подписания
   */
  async runAutosign(provider_nca_key_store_id) {
    return await instance()
      .post("/provider_request/nca_autosign/run/", {
        provider_nca_key_store_id,
      })
      .then((res) => res?.data);
  },
};
